import { createSlice } from '@reduxjs/toolkit';
import { Settings } from '@tests/types';

import { settingsAdapter } from '@/adapters';
import { settingsApi } from '@/services';

interface State {
  settings: Settings;
}

export const settingsSlice = createSlice({
  extraReducers: (build) => {
    build.addMatcher(settingsApi.endpoints.getSettings.matchFulfilled, (state, action) => {
      settingsAdapter.upsertOne(state, action.payload);
    });
  },
  initialState: settingsAdapter.getInitialState<State>({ settings: {} as Settings }),
  name: 'settings',
  reducers: {},
});

export const settingsReducer = settingsSlice.reducer;
